<template>
  <div>
    <loading v-show="load" :fullscrean="true" text="Carregando os dados"/>
    <div v-show="!load">
      <div class="container" style="max-width: 600px">
        <div v-if="!cartoes.length">
          <div class="text-center mt-5">
            <div class="mb-4">
              <icon name="card" class="text-primary" size="48"></icon>
            </div>
            <p>Você ainda não tem nenhum cartão de crédito cadastrado</p>
          </div>
        </div>
        <div v-else>
          <h6 class="text-center mt-4 mb-3">Selecione um cartão</h6>
          <div class="mb-3" v-for="(e, index) in cartoes" :key="index">
            <a href="javascript:" class="card text-dark" @click="selecionarCartao(e);">
              <div class="card-body">
                <div class="d-flex align-items-center">
                  <div class="mr-3">
                    <img v-if="e.payment_method && e.payment_method.thumbnail" :src="e.payment_method.thumbnail" :alt="e.payment_method.name" style="width: 32px">
                    <icon v-else name="card" size="32"></icon>
                  </div>
                  <div class="small">
                    Cartão de Crédito
                    <div class="font-weight-bold">**** **** **** {{ e.last_four_digits }}</div>
                  </div>
                  <div class="ml-auto text-right">
                    <button class="btn text-danger" @click.stop="deletarCartao(e)" title="Remover">
                      <i class="fa fa-trash-o"></i>
                    </button>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>

        <div>
          <hr>
          <button class="btn btn-outline-primary btn-block" @click="cadastrarCartao">Adicionar novo cartão</button>
        </div>

      </div>
    </div>


    <modal ref="modalCartao" @voltar="fecharModalCartao(true)" :title="'Dados do Cartão'" :overflow="true">
      <form @submit.prevent="processarCVV" v-if="menu === 2">
        <div class="container container-endereco">
          <div class="alert alert-info my-4">Por favor informe o código de segurança do seu cartão.</div>
          <div class="mb-3">
            <div id="form-checkout__securityCode-container" class="form-control"></div>
            <label class="small mb-1">Código de segurança (CVV)</label>
            <input name="token" id="token" hidden>
            <div class="small text-danger font-weight-bold ml-1" :class="{'invisible': erroMsg !== 3}">Código de segurança inválido</div>
          </div>
        </div>
        <div class="border-top btn-avancar fixed-container">
          <div class="p-3">
            <button type="submit" class="btn btn-primary btn-block btn-bottom" :disabled="loadCartao">
              <span v-if="loadCartao"><i class="fa fa-spinner fa-pulse"></i> Aguarde</span>
              <span v-else>Enviar</span>
            </button>
          </div>
        </div>
      </form>
      <form id="form-checkout" v-if="menu === 1">
        <div id="containerPagamento" class="container container-endereco">
          <div class="mt-3">
            <div id="alertError" class="alert alert-warning mb-3" v-if="erroMsg" style="font-size: 90%">
              Houve um erro ao processar seu cartão, verifique os dados inseridos e tente novamente.
              <div class="mt-1" v-if="erroMsg !== 99">- {{ erroMsg | erros }}</div>
            </div>
            <div class="form-group mb-2">
              <label class="mb-0 font-weight-bold small">Número do cartão*</label>
              <div id="form-checkout__cardNumber" class="form-control"></div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group mb-2">
                  <label class="mb-0 font-weight-bold small">Data de validade (Mês/Ano)*</label>
                  <div id="form-checkout__expirationDate" class="form-control"></div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group mb-2">
                  <label class="mb-0 font-weight-bold small">Código de segurança (CVV)*</label>
                  <div id="form-checkout__securityCode" class="form-control"></div>
                </div>
              </div>
            </div>
            <div class="form-group mb-2">
              <label class="mb-0 font-weight-bold small">Nome do titular*</label>
              <input type="text" id="form-checkout__cardholderName" class="form-control" required/>
            </div>
            <div class="row">
              <div class="col-sm-6 d-none">
                <div class="form-group mb-2">
                  <select id="form-checkout__issuer" class="form-control"></select>
                </div>
              </div>
              <div class="col-sm-6 d-none">
                <div class="form-group mb-2">
                  <select id="form-checkout__installments" class="form-control"></select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group mb-2">
                  <label class="mb-0 font-weight-bold small">Tipo de identificação*</label>
                  <select id="form-checkout__identificationType" class="form-control"></select>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group mb-2">
                  <label class="mb-0 font-weight-bold small">CPF/CNPJ do Titular*</label>
                  <input type="tel" id="form-checkout__identificationNumber" class="form-control" minlength="11" maxlength="14" v-model="cpfNumber" @blur="validarCPF" required/>
                </div>
              </div>
            </div>
            <div class="form-group mb-3">
              <label class="mb-0 font-weight-bold small">E-mail*</label>
              <input type="email" id="form-checkout__cardholderEmail" class="form-control" required/>
            </div>
          </div>
        </div>
        <div class="fixed-bottom bg-white border-top btn-avancar fixed-container">
          <div class="p-3">
            <button type="submit" id="form-checkout__submit" class="btn btn-primary btn-block btn-bottom" :disabled="loadCartao">
              <span v-if="loadCartao"><i class="fa fa-spinner fa-pulse"></i> Aguarde</span>
              <span v-else>Salvar</span>
            </button>
          </div>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>
import { loadMercadoPago } from "@mercadopago/sdk-js";
import Loading from "../components/Loading";
import Icon from "../components/Icon";
import Modal from "../components/Modal";
import {TheMask} from 'vue-the-mask';

export default {
  name: 'CartoesMercadopago',
  components: {Loading, Icon, Modal, TheMask},
  props: ['pedido', 'dados'],
  data() {
    return {
      token: localStorage.getItem('token'),
      load: true,
      cartoes: [],
      loadCartao: false,
      mp: null,
      cardForm: null,
      securityCodeElement: null,
      erroMsg: null,
      menu: 1,
      cartao: null,
      cpfNumber: ''
    }
  },

  methods: {
    selecionarCartao(cartao) {
      this.cartao = {
        id: cartao.id,
        paymentMethodId: cartao.payment_method.id,
        issuerId: cartao.issuer.id,
        customer_id: cartao.customer_id,
        installments: 1
      };

      this.menu = 2;
      this.$nextTick(() => {
        this.instanciarFormMp();
        this.$emit('openModal');
      });
    },

    async processarCVV() {
      if (this.loadCartao) {
        return;
      }

      this.loadCartao = true;

      try {
        const token = await this.mp.fields.createCardToken({ cardId: this.cartao.id });
        this.cartao.token = token.id;
        this.cartao.saveCartao = 0;
        this.processarPagamento();

      } catch (e) {
        this.loadCartao = false;
        this.$swal("Não conseguimos processar seu pagamento." + (e ? "\nErro: " + e : ""));
      }
    },

    processarPagamento() {
      this.loadCartao = true;
      this.$store.state.load = "Processando pagamento";

      this.$http.post(this.pedido.token + '/' + this.token + '/pix-mercado-pago', { ...this.dados, cartao: this.cartao })
        .then(response => {
          this.loadCartao = false;
          this.$store.state.load = false;

          if (response.data && response.data.result && response.data.status === 'approved') {
            this.fecharModalCartao();
            this.$swal("Pagamento realizado com sucesso! Aguarde para aceitarmos o seu pedido.");
            this.$emit('atualizar', true);

          } else {
            this.$swal("Não conseguimos processar seu pagamento. Verifique o código de segurança ou tente com outro cartão.");
          }

        }, res => {
          this.loadCartao = false;
          this.$store.state.load = false;
          const msg = res.data ? res.data.msg : null;
          this.$swal("Não conseguimos processar seu pagamento." + (msg ? "\nErro: " + msg : ""));

          if (res.data.status === 'rejected') {
            this.clearForms();

            setTimeout(() => {
              this.instanciarFormMp();
            }, 2000);
          }
        });

    },

    fecharModalCartao(clear) {
      this.$emit('closeModal');

      if (clear) {
        this.clearForms();
      }
    },

    clearForms() {
      if (this.cardForm) {
        this.cardForm.unmount();
        this.cardForm = null;
      }

      if (this.securityCodeElement) {
        this.securityCodeElement.unmount();
        this.securityCodeElement = null;
      }
    },

    buscarCartoes(callback) {
      this.load = true;
      this.$http.get(this.$store.state.base_url + this.token + '/cartao/buscar?plataforma=1')
        .then(response => {
          this.load = false;

          if (response.data) {
            this.cartoes = response.data || [];

            if (!this.cartoes.length) {
              this.cadastrarCartao();

            } else if (callback) {
              callback();
            }
          }

        }, res => {
          this.load = false;
          let msg = res.data && res.data.msg ? res.data.msg : 'Erro temporário';
          this.$swal(msg);
        });
    },

    deletarCartao(cartao) {
      this.$swal({
        text: 'Deseja realmente deletar o cartão?',
        buttons: ["Não", "Sim"],
        dangerMode: true
      }).then((res) => {
        if (res) {
          this.load = true;
          cartao.plataforma = 1;
          this.$http.post(this.$store.state.base_url + this.token + '/cartao/deletar', cartao).then(response => {
            this.load = false;

            if (response.data && response.data.success) {
              this.$swal("Cartão deletado com sucesso!");
              this.cartoes = this.cartoes.filter(c => c.id !== cartao.id);
            }

          }, res => {
            let msg = res.data && res.data.response ? res.data.response : 'Erro temporário';
            this.$swal(msg);
            this.load = false;
          });
        }
      });
    },

    cadastrarCartao() {
      this.menu = 1;
      this.$nextTick(() => {
        this.instanciarFormMp();
        this.$emit('openModal');
      })
    },

    instanciarFormMp() {
      if (!this.mp) {
        return;
      }

      if (this.menu === 2) {
        if (this.securityCodeElement) {
          return;
        }

        this.securityCodeElement = this.mp.fields.create('securityCode', { placeholder: "CVV" });
        this.securityCodeElement.mount('form-checkout__securityCode-container')
        return;
      }

      if (this.cardForm) {
        return;
      }

      const form = {
        id: "form-checkout",
        cardNumber: {
          id: "form-checkout__cardNumber",
          placeholder: "Número do cartão",
          style: { fontFamily: "Raleway" },
          customFonts: [{src: "https://fonts.googleapis.com/css2?family=Raleway"}]
        },
        expirationDate: {
          id: "form-checkout__expirationDate",
          placeholder: "MM/AA (Ex 10/29)",
          style: { fontFamily: "Raleway" },
          customFonts: [{src: "https://fonts.googleapis.com/css2?family=Raleway"}]
        },
        securityCode: {
          id: "form-checkout__securityCode",
          placeholder: "Código de segurança",
          style: { fontFamily: "Raleway" },
          customFonts: [{src: "https://fonts.googleapis.com/css2?family=Raleway"}]
        },
        cardholderName: {
          id: "form-checkout__cardholderName",
          placeholder: "Titular do cartão",
        },
        issuer: {
          id: "form-checkout__issuer",
          placeholder: "Banco emissor",
        },
        installments: {
          id: "form-checkout__installments",
          placeholder: "Parcelas",
        },
        identificationType: {
          id: "form-checkout__identificationType",
          placeholder: "Tipo de documento",
        },
        identificationNumber: {
          id: "form-checkout__identificationNumber",
          placeholder: "Número do documento",
        },
        cardholderEmail: {
          id: "form-checkout__cardholderEmail",
          placeholder: "E-mail",
        },
      }

      this.cardForm = this.mp.cardForm({
        amount: this.pedido ? this.pedido.valor_total : "0.5",
        autoMount: false,
        iframe: true,
        form,

        callbacks: {
          onFormMounted: error => {
            if (error) return console.warn("Form Mounted handling error: ", error);
            console.log("Form mounted");
          },

          onCardTokenReceived: (errorData, token) => {
            this.erroMsg = this.validarMsgCartao(errorData);

            if (this.erroMsg) {
              this.loadCartao = false;
              this.$emit('scrollTop');
              return null;
            }

            return token;
          },

          onSubmit: event => {
            this.loadCartao = true;
            event.preventDefault();
            const data = this.cardForm.getCardFormData();

            if (!data) {
              this.loadCartao = false;
              return;
            }

            if (this.pedido) {
              this.loadCartao = true;
              data.plataforma = 1;
              data.saveCartao = 1;
              this.cartao = data;
              this.processarPagamento();

            } else {
              this.loadCartao = false;
              this.buscarCartoes();
              this.fecharModalCartao(true);
              this.$swal("Cartão criado com sucesso!");
            }
          },

          onFetching: (resource) => {
            if (resource === 'cardToken') {
              this.loadCartao = true;
            }

            return () => {}
          }
        },
      });

      this.cardForm.mount();
    },

    iniciarMP() {
      loadMercadoPago().then(() => {
        if (this.empresa.mp_public_key) {
          this.mp = new window.MercadoPago(this.empresa.mp_public_key);
        }
      })
    },

    validarMsgCartao(errorData) {
      const error = errorData && errorData.length ? (errorData[0].field || errorData[0].code) : null;

      if (error) {
        switch (error) {
          case "cardNumber":
          case '205':
          case 'E301':
            return 1;
          case "expirationDate":
          case '208':
          case '224':
          case '325':
          case '326':
          case 'E203':
            return 2;
          case "securityCode":
            return 3;
          case 'cardholderName':
          case '221':
          case '316':
            return 4;
          case 'identificationNumber':
          case '214':
          case '324':
            return 5;
          case 'cardholderEmail':
            return 6;
          default:
            return 99;
        }
      }

      return null;
    },

    validarCPF() {
      this.cpfNumber = this.cpfNumber.replace(/[^0-9]+/g, "");
    }
  },

  created() {
    document.body.classList.remove("modal-open");
  },

  mounted() {
    this.url = this.origin === '5' ? '/' + this.$store.state.empresa.dominio_delivery : '';

    if (this.token) {
      window.scrollTo(0, 0);
      this.iniciarMP();
      this.buscarCartoes();
    }
  },

  computed: {
    empresa() {
      return this.$store.state.empresa
    }
  },

  beforeDestroy() {
    if (this.cardForm) {
      this.cardForm.unmount();
    }

    if (this.securityCodeElement) {
      this.securityCodeElement.unmount();
    }
  },

  filters: {
    erros(e) {
      switch (e) {
        case 1:
          return 'Informe um número de cartão válido';
        case 2:
          return 'Data de expiração inválida';
        case 3:
          return 'Código de segurança inválido';
        case 4:
          return 'Nome do titular inválido';
        case 5:
          return 'CPF / CNPJ inválido';
        case 6:
          return 'Email inválido';
        default:
          return 'Confira os dados os dados do cartão';
      }
    }
  }
}
</script>

<style scoped>
.btn-avancar {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
  background-color: #fff;
}

.container-endereco {
  padding-bottom: 80px;
}

@media (min-width: 768px) {
  .btn-avancar {
    position: static;
    padding-right: 15px;
    padding-left: 15px;
  }

  .container-endereco {
    overflow: auto;
    height: calc(80vh - 142px);
    padding-bottom: 0;
  }
}
</style>
